<template>
  <div class="overlay">
    <svg viewBox="0 0 95 100" class="icon">
      <g>
        <circle cx="35.6" cy="28.1" r="1.6"></circle>
        <circle cx="45.7" cy="28.1" r="1.6"></circle>
        <path
          d="M82.8,34.5H53.5c0.5-1.7,0.8-3.6,0.8-5.5c0-8.9-1.1-18.4-13.3-18.4c-6,0-13.2,3.2-13.3,18.4c0,2.1,0.4,4.1,1,6   c-1.7,0.8-2.9,2.5-2.9,4.5v5.9c-4.7,1.8-8.9,5.7-8.9,12.6v4.3h-12c-0.8,0-1.6,0.3-2.1,0.9c-0.5,0.7-0.7,1.5-0.6,2.3L6,86.8   c0.1,0.5,0.2,0.9,0.5,1.3c-0.4,0.1-0.7,0.5-0.7,0.9c0,0.5,0.4,0.9,0.9,1l0,0h0.1h9.1h2h22.5h23.7h9h0.3c0.1,0,0.2,0,0.2-0.1   c1.4-0.3,2.5-1.5,2.5-2.9c0-1.6-1.3-3-3-3h-7.7v-6.1h17.4c2.7,0,5-2.2,5-5V39.5C87.8,36.7,85.5,34.5,82.8,34.5z M33.9,20.4   c-0.7,1-1.6,1.6-2.3,1.6c-0.4,0-0.6-0.1-0.8-0.4c0-0.1-0.1-0.1-0.1-0.1c0.4-1.5,0.9-2.8,1.5-3.9C32.5,18.6,33.1,19.5,33.9,20.4z    M36,19.7c-0.1-0.1-0.2-0.2-0.3-0.3c-1.1-1.2-1.8-2.5-2-3.9c0.4-0.4,0.8-0.8,1.2-1.1c0.6,1.8,1.9,3.4,3.8,4.6c2.1,1.3,4.6,2,7.3,2   c1.8,0,3.7-0.3,5.5-1c0.2,0.6,0.3,1.2,0.4,1.9C47,23.7,41.5,23.4,37.7,21C37,20.6,36.5,20.1,36,19.7z M38.6,12.8   c1.7,3.4,5,4.3,8.2,4.3c1.2,0,2.3-0.2,3.4-0.3c0.2,0.4,0.4,0.8,0.6,1.2c-4,1.4-8.1,1.1-11.2-0.8c-1.6-1.1-2.7-2.5-3-3.9   C37.3,13.2,37.9,13,38.6,12.8z M41.1,12.6c3.4,0,5.9,0.8,7.6,2.3c-4.7,0.4-6.7-0.7-7.7-2.3C41,12.6,41,12.6,41.1,12.6z M29.9,29   c0-1.9,0.1-3.7,0.3-5.2c0.4,0.2,0.9,0.3,1.4,0.3c0.1,0,0.1,0,0.1,0c1.4-0.1,2.7-1,3.7-2.3c0.4,0.3,0.8,0.6,1.3,0.9   c2.6,1.6,5.7,2.4,8.9,2.4c2.2,0,4.5-0.4,6.6-1.1c0.1,1.5,0.2,3.2,0.2,5c0.1,1.9-0.2,3.8-0.8,5.5H30.8c0,0,0,0-0.1,0   C30.2,32.8,29.9,30.9,29.9,29z M4.2,65.2c-0.1-0.3,0-0.5,0.1-0.6c0.1-0.1,0.3-0.2,0.5-0.2h14.6c0.6,0,1.2,0.5,1.3,1.1l3.8,21.3   c0.1,0.3,0,0.5-0.1,0.6c-0.1,0.1-0.3,0.2-0.5,0.2h-7.6l2-11.8v-0.2c0-1.6-1.5-2.9-2.7-2.9h-3.9c-1.2,0-2.6,1.2-2.7,2.8l-1.4,8.8   L4.2,65.2z M14.1,87.6H9.3c-0.1,0-0.1,0-0.2,0l1.8-11.8v-0.2c0-0.4,0.5-0.8,0.6-0.8h3.9c0.2,0.1,0.6,0.4,0.6,0.8L14.1,87.6z    M73.1,86c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H40.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h7.8h17.2H73.1z M40.4,84   c-1.6,0-3,1.3-3,3c0,0.4,0.1,0.7,0.2,1H26.4c0.2-0.5,0.3-1.1,0.2-1.6l-3.8-21.3c-0.2-1.6-1.7-2.8-3.3-2.8h-0.6V58   c0-6.1,3.8-9,6.9-10.3v25.2c0,2.8,2.3,5,5,5h17.4V84H40.4z M50.3,83.9l0-27.2c0-1.6,1.5-2.9,2.4-2.9h8.2c1,0,2.4,1.3,2.4,2.9v27.2   H50.3z M85.7,72.9c0,1.6-1.3,2.9-2.9,2.9H65.4V56.7c0-2.8-2.5-5-4.5-5h-8.2c-2.1,0-4.5,2.2-4.5,5v19.1H30.8c-1.6,0-2.9-1.3-2.9-2.9   V39.5c0-1.6,1.3-2.9,2.9-2.9h52c1.6,0,2.9,1.3,2.9,2.9V72.9z"
        ></path>
      </g>
    </svg>
    <div class="spinner"></div>
  </div>
</template>

<style lang='sass' scoped>
@import '@/assets/_variables.sass'

.overlay
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 6
  background: #292f36
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  opacity: 1

  .icon
    max-width: 80px
    width: 100%
    height: auto
    fill: $c-bittersweet
    margin-bottom: 40px

    @media only screen and (min-width: 501px)
      max-width: 100px

    @media only screen and (min-width: 801px)
      max-width: 120px

    @media only screen and (min-width: 1101px)
      max-width: 140px

    @media only screen and (min-width: 1501px)
      max-width: 160px

  .spinner
    height: 25px
    width: 25px
    background: $c-apple-green
    background: $c-bittersweet
    animation: loading 1.2s infinite ease-in-out

    @media only screen and (min-width: 801px)
      height: 35px
      width: 35px

    @media only screen and (min-width: 1501px)
      height: 45px
      width: 45px

  @keyframes loading
    0%
      transform: perspective(120px) rotateX(0deg) rotateY(0deg)
    50%
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
    100%
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg)
</style>